import { pickLocale } from "@/lib/localize";

/**
 * Shown when pickLocale() had to fall back to the other language for any of
 * the given bilingual fields — the fallback is never silent (Bilingual Rules).
 */

const MESSAGES = {
  nl: "Deze inhoud is nog niet volledig in het Nederlands beschikbaar. U leest een andere taalversie.",
  en: "This content is not yet fully available in English. You are reading another language version.",
  de: "Dieser Inhalt ist noch nicht vollständig auf Deutsch verfügbar. Sie lesen eine andere Sprachfassung.",
  fr: "Ce contenu n'est pas encore entièrement disponible en français. Vous lisez une autre version linguistique.",
  es: "Este contenido aún no está totalmente disponible en español. Está leyendo otra versión lingüística.",
};

export function isLocaleFallback(field, lang) {
  if (!field || typeof field === "string") return false;
  const primary = field[lang];
  if (primary && String(primary).trim()) return false;
  return !!pickLocale(field, lang);
}

export const TranslationFallbackNotice = ({ fields, lang }) => {
  const fallback = (fields || []).some((f) => isLocaleFallback(f, lang));
  if (!fallback) return null;
  return (
    <div
      data-testid="translation-fallback-banner"
      role="note"
      className="mb-8 rounded-sm border border-gold/40 bg-gold/10 px-4 py-3 text-sm text-gold font-serif italic"
    >
      {MESSAGES[lang] || MESSAGES.en}
    </div>
  );
};
